import TokenTable from './TokenTable';
// import connect from './connect'

export default TokenTable;



// WEBPACK FOOTER //
// ./src/components/TokenTable/index.js